webpackJsonp([14],{

/***/ 1057:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_SmallLoadingSpinner__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_LoginErrorMessages__ = __webpack_require__(1039);



/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:00:22
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



// CHILD COMPONENTS ////////////////////////////////////////////////////////////



// COMPONENT ///////////////////////////////////////////////////////////////////
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginCreatePasswordForm',

  components: {
    LoginErrorMessages: __WEBPACK_IMPORTED_MODULE_5__components_Login_LoginErrorMessages__["a" /* default */], SmallLoadingSpinner: __WEBPACK_IMPORTED_MODULE_4__components_Common_SmallLoadingSpinner__["a" /* default */]
  },

  props: ['loginCredentialsIncorrect', 'loginLoadingActive'],

  data: function data() {
    return {
      newPassword: null,
      passwordRepeat: null,
      passwordHidden: true
    };
  },
  beforeMount: function beforeMount() {
    this.resetPasswords();
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['authType'])),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setPassword', 'undoLoginState', 'submitSetNewPassword']), {
    submitNewPassword: function submitNewPassword() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newPassword;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newPassword = _this.newPassword;

                if (!(_this.authType === 'createNewPasswordForRegisteredUser')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return _this.submitSetNewPassword({ newPassword: newPassword });

              case 4:
                _this.$toaster.success('Hasło zostało zmienione');
                _context.next = 10;
                break;

              case 7:
                _context.next = 9;
                return _this.setPassword({ newPassword: newPassword });

              case 9:
                _this.$toaster.success('Hasło zostało zapisane. Możesz się teraz zalogować');

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    togglePasswordVisiblity: function togglePasswordVisiblity() {
      if (this.passwordHidden) {
        document.querySelector('.login-form__input--password').type = 'text';
        this.passwordHidden = false;
      } else {
        document.querySelector('.login-form__input--password').type = 'password';
        this.passwordHidden = true;
      }
    },
    resetPasswords: function resetPasswords() {
      this.newPassword = null;
      this.passwordRepeat = null;
    }
  })
});

/***/ }),

/***/ 1260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(1057);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6580a80b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1263);
function injectStyle (ssrContext) {
  __webpack_require__(1261)
}
var normalizeComponent = __webpack_require__(18)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6580a80b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1262);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1015)("44f40e49", content, true, {});

/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1014)(true);
// imports


// module
exports.push([module.i, ".content__back-to-top{cursor:pointer;position:relative;display:inline-block;margin-top:10px;font-size:12px}.content__back-to-top:hover{text-decoration:underline}.login-form__input--password{width:82%;display:inline-block;float:left}@media screen and (max-width:768px){.login-form__input--password{width:75%}}.login-form__show-password{max-width:20%;float:right;padding-top:8px}", "", {"version":3,"sources":["/builds/new-media/lajt-online.pl/platform/src/components/Login/LoginCreatePasswordForm/style.sass"],"names":[],"mappings":"AACA,sBACE,eAAgB,AAChB,kBAAmB,AACnB,qBAAsB,AACtB,gBAAiB,AACjB,cAAgB,CACjB,AACD,4BACE,yBAA2B,CAC5B,AACD,6BACE,UAAW,AACX,qBAAsB,AACtB,UAAY,CACb,AACD,oCACA,6BACM,SAAW,CAChB,CACA,AACD,2BACE,cAAe,AACf,YAAa,AACb,eAAiB,CAClB","file":"style.sass","sourcesContent":["\n.content__back-to-top {\n  cursor: pointer;\n  position: relative;\n  display: inline-block;\n  margin-top: 10px;\n  font-size: 12px;\n}\n.content__back-to-top:hover {\n  text-decoration: underline;\n}\n.login-form__input--password {\n  width: 82%;\n  display: inline-block;\n  float: left;\n}\n@media screen and (max-width: 768px) {\n.login-form__input--password {\n      width: 75%;\n}\n}\n.login-form__show-password {\n  max-width: 20%;\n  float: right;\n  padding-top: 8px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper"},[_c('form',{staticClass:"login-form",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"login__content",class:{ 'login__content--loading' : _vm.loginLoadingActive }},[_c('h2',{staticClass:"login-form__heading"},[_vm._v("Stwórz nowe hasło")]),_vm._v(" "),_c('p',{staticClass:"login-form__lead"},[_vm._v("Hasło musi zawierać co najmniej 8 znaków, jedną dużą literę oraz jedną cyfrę.")]),_vm._v(" "),(_vm.loginCredentialsIncorrect)?_c('LoginErrorMessages'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"login-form__input login-form__input--password form-control input-lg",attrs:{"type":"password","name":"password","placeholder":"Nowe hasło","autofocus":""},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn button login-form__show-password",on:{"click":_vm.togglePasswordVisiblity}},[(_vm.passwordHidden)?_c('icon',{attrs:{"name":"eye","scale":"1.5"}}):_vm._e(),(!_vm.passwordHidden)?_c('icon',{attrs:{"name":"eye-slash","scale":"1.5"}}):_vm._e()],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordRepeat),expression:"passwordRepeat"}],staticClass:"login-form__input form-control input-lg",attrs:{"type":"password","name":"password-repeat","placeholder":"Powtórz hasło"},domProps:{"value":(_vm.passwordRepeat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordRepeat=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn button btn-lg btn-block",attrs:{"disabled":!_vm.newPassword || _vm.newPassword.length < 8 || !(_vm.newPassword === _vm.passwordRepeat)},on:{"click":_vm.submitNewPassword}},[_vm._v("Dalej")]),_vm._v(" "),_c('span',{staticClass:"content__back-to-top",on:{"click":function($event){return _vm.undoLoginState('initial')}}},[_vm._v("rozpocznij od nowa")])])],1)]),_vm._v(" "),_c('SmallLoadingSpinner',{attrs:{"is-visible":_vm.loginLoadingActive}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.2ccc8635a5086e10c4c0.js